import { render, staticRenderFns } from "./switch-control2.vue?vue&type=template&id=70228b0b"
import script from "./switch-control2.vue?vue&type=script&lang=js"
export * from "./switch-control2.vue?vue&type=script&lang=js"
import style0 from "./switch-control2.vue?vue&type=style&index=0&id=70228b0b&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70228b0b')) {
      api.createRecord('70228b0b', component.options)
    } else {
      api.reload('70228b0b', component.options)
    }
    module.hot.accept("./switch-control2.vue?vue&type=template&id=70228b0b", function () {
      api.rerender('70228b0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leaflet-map/switch-control2.vue"
export default component.exports